import {getMasterModuleService} from '../features/modules/services'
import {RoomAvailableDto} from '../features/room/models'
import {getRoomsAvailableService, getRoomsService} from '../services/room.service'

export const useRooms = () => {
  const getTypeRooms = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 200,
        tableName: 'TipoHabitacion',
      })
      const data = response.data.data
      const mappedMaster = data?.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
      }))
      return mappedMaster
    } catch (error) {
      console.log(error)
      return []
    }
  }

  const getRooms = async (filter: any) => {
    try {
      const {data: response} = await getRoomsService({
        pageNumber: 1,
        size: 1000,
        ...filter,
      })
      const mappedRooms = response?.data?.map((item) => ({
        value: item.Id,
        label: item.Codigo,
        ...item,
      }))
      return mappedRooms
    } catch (error) {
      return []
    }
  }

  const getRoomsAvailable = async (filter: RoomAvailableDto) => {
    try {
      const {data: response} = await getRoomsAvailableService({
        ...filter,
      })
      const mappedRooms = response?.data?.map((item) => ({
        value: item.Id,
        label: item.Codigo,
        ...item,
      }))
      return mappedRooms
    } catch (error) {
      return []
    }
  }

  const getGenresRooms = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 200,
        tableName: 'Sexo',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
      }))
      return mappedMaster
    } catch (error) {
      console.log(error)
      return []
    }
  }
  const getBathroomsTypeRooms = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 200,
        tableName: 'TipoBanio',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
      }))
      return mappedMaster
    } catch (error) {
      console.log(error)
      return []
    }
  }

  const getLevelsRoom = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'Nivel',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
      }))
      return mappedMaster
    } catch (error) {
      console.log(error)
      return []
    }
  }

  const getStatusRoom = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'EstadoHabitacion',
      })
      const data = response.data.data
      const mappedModuleTypes = data?.map((moduleType) => ({
        value: moduleType.id,
        label: moduleType.nombreCorto,
      }))
      return mappedModuleTypes
    } catch (error) {
      console.log(error)
      return []
    }
  }

  const getSubStatusRoom = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'SubEstadoHabitacion',
      })
      const data = response.data.data
      const mappedModuleTypes = data?.map((moduleType) => ({
        value: moduleType.id,
        label: moduleType.nombreCorto,
      }))
      return mappedModuleTypes
    } catch (error) {
      console.log(error)
      return []
    }
  }

  return {
    getTypeRooms,
    getGenresRooms,
    getBathroomsTypeRooms,
    getLevelsRoom,
    getStatusRoom,
    getSubStatusRoom,
    getRooms,
    getRoomsAvailable,
  }
}
